import styles from "../styles/Experience.module.scss";

function Experience(props) {
  return (
    <div>
      <MainContainer />
    </div>
  );
}

function MainContainer() {
  return (
    <div className={styles.maincontainer}>
      <TitleDescription />
      <ServiceItemRow />
    </div>
  );
}

function TitleDescription() {
  return (
    <div className={styles.titledescriptioncontainer}>
      <div className={styles.title}>Experience </div>
      <div className={styles.description}>
        Over the years I have worked on many mobile applications and websites.
      </div>
    </div>
  );
}

export function ServiceItemRow() {
  return (
    <div className={styles.allexperiences}>
      <ServiceItem />
      <ServiceItem />
      <ServiceItem />
    </div>
  );
}

export function ServiceItem() {
  return (
    <div className={styles.experiencecontainer}>
      <div className={styles.experienceitemline} />
      <div className={styles.experiencedetailscontainer}>
        <div className={styles.role}>UI UX Designer</div>
        <div className={styles.company}>XCompany in Huston</div>
        <div className={styles.duration}>2021 - 2022</div>
      </div>
    </div>
  );
}

export default Experience;
